<template>
  <section>
    <v-progress-linear indeterminate color="primary" v-if="usersLoading" absolute class="mt-n3" height="7"></v-progress-linear>
    <v-btn fab color="primary" bottom right absolute @click="addUser()">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-row v-if="!usersLoading && !listUsers.length && !newUser">
      <v-col class="px-6" cols="12">
        <v-alert class="body-1" border="left" color="accent" dark>
          You don't have any additional users yet, use the
          <v-icon color="primary">mdi-plus</v-icon>button to add a new user.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="newUser">
      <v-col class="px-6" cols="12">
        <UserCard :user="newUser" :roles="roles" :saved="saved"></UserCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="px-6"
        cols="12"
        :md="listUsers.length === 1 ? 12 : (listUsers.length === 2 ? 6 : 4)"
        v-for="(user, index) in listUsers"
        :key="index"
      >
        <div style="position:relative">
          <UserCard :user="user" :roles="roles"></UserCard>
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { models, makeFindMixin } from "feathers-vuex";
import UserCard from "@/components/config/user/UserCard";

export default {
  data: () => ({
    fab: null,
    newUser: null,
  }),
  created() {},
  mounted() {},
  mixins: [
    makeFindMixin({ service: "roles" }),
    makeFindMixin({ service: "users" }),
  ],
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    usersLoading() {
      return this.isFindUsersPending;
    },
    listUsers() {
      return this.users && this.users.filter((user) => this.user.id !== user.id);
    },
    rolesParams() {
      return {
        query: { $ne: { system: true } },
      };
    },
    usersParams() {
      return {
        query: { $eager: "roles" },
      };
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    addUser() {
      const { User } = models.api;
      let user = new User();
      this.newUser = user;
    },
    refresh() {
      this.findUsers();
    },
    saved() {
      this.newUser = null;
      this.refresh();
    },
  },
  watch: {},
  components: {
    UserCard,
  },
};
</script>